export const MAINTENANCE = "maintenance";
export const SCHEDULED = "scheduled";
